@if (
  {
    currentStepIndex: currentStepIndex(),
    loading: loading()
  };
  as STATE
) {
  <article class="onboarding-container">
    <section class="image-pane">
      <img
        [src]="steps[STATE.currentStepIndex].image"
        alt="Illustration du guide"
        class="step-image"
        onerror="this.src = 'assets/images/logo-veone.png'"
        priority
      />
    </section>

    <article class="content-pane">
      <section class="text-content">
        <hgroup>
          <h2 class="title">{{ steps[STATE.currentStepIndex].title }}</h2>

          <p class="subTitle">
            {{ steps[STATE.currentStepIndex].subTitle }}
          </p>
        </hgroup>

        <hr class="separator" />
        <hgroup>
          <p class="description">
            {{ steps[STATE.currentStepIndex].description }}
          </p>
          <br />
          <p class="sub-description">
            {{ steps[STATE.currentStepIndex].subDescription }}
          </p>
        </hgroup>
        <hr class="separator" />
      </section>

      <section class="navigation-area">
        <div class="pagination-dots">
          @for (step of steps; track step.id; let i = $index) {
            <button
              class="dot"
              [class.active]="i === STATE.currentStepIndex"
              [attr.aria-label]="'Aller à l\'étape ' + (i + 1)"
            ></button>
          }
        </div>

        <div class="actions">
          @if (STATE.currentStepIndex > 0) {
            <button
              mat-stroked-button
              class="prev-btn"
              (click)="prev()"
              [disabled]="STATE.loading"
            >
              Précédent
            </button>
          }

          <button
            class="action-btn"
            (click)="next()"
            [disabled]="STATE.loading"
            [class.is-loading]="STATE.loading"
          >
            @if (STATE.currentStepIndex === 0) {
              Découvrir les nouveautés
            } @else if (STATE.currentStepIndex === steps.length - 1) {
              Aller au tableau de bord
            } @else {
              Suivant
            }
          </button>
        </div>
      </section>
    </article>
  </article>
}
